import getSourceTypeForMailboxInfo from "./getSourceTypeForMailboxInfo";
import { setSourceTypeForMailboxInfoFunc } from "owa-auth-types/lib/getIdentityInfoForMailboxInfo";

export function initializeTryLookupIdentityInfo(): void {
    // In order to lookup identity info for a mailbox, we need to know the source type of the mailbox. So
    // we need to tell the owa-auth-type the function that it should use for looking up the source types
    setSourceTypeForMailboxInfoFunc(getSourceTypeForMailboxInfo);
}
